/**
 * @name lighthouse
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgM1YyIiAvPgogIDxwYXRoIGQ9Ik0xNi4wNjYgMTYuODY1IDcgMjJsMi0xMVY2YTMgMyAwIDAxNiAwdjVsMiAxMSIgLz4KICA8cGF0aCBkPSJtMTkuNzkyIDQuNS44NjYtLjUiIC8+CiAgPHBhdGggZD0ibTE5Ljc5NyAxMy41Ljg2Ni41IiAvPgogIDxwYXRoIGQ9Ik0yMSA5aDEiIC8+CiAgPHBhdGggZD0iTTMgOUgyIiAvPgogIDxwYXRoIGQ9Im00LjIwMyAxMy41LS44NjYuNSIgLz4KICA8cGF0aCBkPSJNNC4yMDggNC41IDMuMzQyIDQiIC8+CiAgPHBhdGggZD0iTTUuNSAyMmgxMyIgLz4KICA8cGF0aCBkPSJtNy45MzIgMTYuODc1IDcuMzc3LTQuMTc4IiAvPgogIDxwYXRoIGQ9Ik04IDExaDgiIC8+CiAgPHBhdGggZD0iTTggN2g4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/lighthouse
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Lighthouse: string = `
<svg
  class="lucide lucide-lighthouse"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M12 3V2" />
  <path d="M16.066 16.865 7 22l2-11V6a3 3 0 016 0v5l2 11" />
  <path d="m19.792 4.5.866-.5" />
  <path d="m19.797 13.5.866.5" />
  <path d="M21 9h1" />
  <path d="M3 9H2" />
  <path d="m4.203 13.5-.866.5" />
  <path d="M4.208 4.5 3.342 4" />
  <path d="M5.5 22h13" />
  <path d="m7.932 16.875 7.377-4.178" />
  <path d="M8 11h8" />
  <path d="M8 7h8" />
</svg>
`;

export default Lighthouse;
